var AccountListFactory = function ($resource, $window) {
    let liveUrl = __baseApiUrl__ + "/participant-web-services/rest/accounts/summary";
    let mockUrl = "assets/data/get-account-summary.json";

    return {
        accountSummary: $resource(
            liveUrl,

            {},
            {
                query: {
                    method: "GET",
                    isArray: false
                }
            }
        )
    }; // End of return
};

AccountListFactory.$inject = ["$resource", "$window"];
export default AccountListFactory;
